import { } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { Chip, Box, Stack } from "@mui/material";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell } from "@shared/components";
import { Product } from "@modules/defaultProducts/types";

export function useProductsListColumns(
  onRefetch: () => void,
  translate: (key: string) => string,
  onEdit: (row: Product) => void
): GridColDef[] {
  return [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },
    {
      field: "name",
      headerName: "Nome",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "is_bookstore",
      headerName: "Bookstore",
      width: 120,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Sim" : "Não"}
          color={params.value ? "success" : "default"}
          size="small"
        />
      ),
    },
    {
      field: "is_superapp",
      headerName: "Super App",
      width: 110,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Sim" : "Não"}
          color={params.value ? "primary" : "default"}
          size="small"
        />
      ),
    },
    {
      field: "metadata",
      headerName: "Metadata",
      width: 150,
      renderCell: (params) => {
        const metadata = params.value || {};
        const metadataArray = Object.values(metadata);
        const requiredCount = metadataArray?.filter((m: any) => m.obrigatorio).length;
        return (
          <Stack height={'100%'} direction={'row'} alignItems="center" justifyContent="center" gap={0.5}>
            <Chip
              label={`${metadataArray.length} total`}
              variant="outlined"
              size="small"
            />
            {requiredCount > 0 && (
              <Chip
                label={`${requiredCount} obr.`}
                color="warning"
                size="small"
                variant="outlined"
              />
            )}
          </Stack >
        );
      },
    },
    {
      field: "actions",
      headerName: "Ações",
      headerAlign: "center",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <TableCell.Container align="center">
          <EditButton hideText onClick={() => onEdit(params.row)} />
          <DeleteButton
            hideText
            recordItemId={params.row.id}
            resource="v1/default_product_admin"
            onSuccess={onRefetch}
          />
        </TableCell.Container>
      ),
    },
  ];
}
